/**
 * Script para verificar que las funciones de Firebase estén disponibles
 */

// Exportar para que TypeScript considere esto un módulo
export {};

// Función para verificar funciones de Firebase
(window as any).checkFirebaseFunctions = function() {
  console.log('🔍 Verificando funciones de Firebase...');
  
  if (typeof window !== 'undefined' && (window as any).auth) {
    const auth = (window as any).auth;
    
    const functions = [
      'db', 'auth', 'storage',
      'collection', 'doc', 'getDoc', 'getDocs', 'setDoc', 'updateDoc', 'addDoc', 'deleteDoc',
      'query', 'where', 'orderBy', 'serverTimestamp',
      'ref', 'uploadBytes', 'getDownloadURL', 'deleteObject', 'listAll', 'getMetadata'
    ];
    
    console.log('📋 Estado de funciones:');
    functions.forEach(func => {
      const available = typeof auth[func] === 'function';
      console.log(`   ${available ? '✅' : '❌'} ${func}: ${typeof auth[func]}`);
    });
    
    // Verificar específicamente las funciones problemáticas
    console.log('\n🎯 Funciones críticas:');
    console.log(`   query: ${typeof auth.query}`);
    console.log(`   where: ${typeof auth.where}`);
    console.log(`   orderBy: ${typeof auth.orderBy}`);
    
    return {
      allAvailable: functions.every(func => typeof auth[func] === 'function'),
      criticalFunctions: {
        query: typeof auth.query === 'function',
        where: typeof auth.where === 'function',
        orderBy: typeof auth.orderBy === 'function'
      }
    };
    
  } else {
    console.log('❌ Firebase no disponible');
    return false;
  }
};

// Función para probar carga de categorías
(window as any).testCategoryLoading = async function() {
  console.log('🧪 Probando carga de categorías...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    console.log('📦 Servicio importado correctamente');
    
    const categories = await optimizedService.getCategories();
    console.log(`📊 Categorías cargadas: ${categories.length}`);
    
    if (categories.length > 0) {
      console.log('📋 Categorías encontradas:');
      categories.forEach((category, index) => {
        console.log(`   ${index + 1}. ${category.name} (${category.id}) - Habilitada: ${category.enabled !== false}`);
      });
    } else {
      console.log('⚠️ No hay categorías en la base de datos');
    }
    
    return categories;
    
  } catch (error) {
    console.error('❌ Error cargando categorías:', error instanceof Error ? error.message : error);
    throw error;
  }
};

console.log('🔍 Scripts de verificación cargados:');
console.log('- window.checkFirebaseFunctions() - Verificar funciones disponibles');
console.log('- window.testCategoryLoading() - Probar carga de categorías');
